module.exports = __webpack_public_path__ + "static/media/inferno.b304b72b.png";